import { DismissablePromptKey } from '@ms/yammer-data/dist/state/types';

import { useLoadDismissablePrompts, useShouldStartDismissablePrompt } from '../dismissablePrompts';

const promptKey = DismissablePromptKey.FirstRunExperience;

type UseShouldStartFirstRunExperience = () => boolean;
export const useShouldStartFirstRunExperience: UseShouldStartFirstRunExperience = () => {
  useLoadDismissablePrompts({ promptKeys: [promptKey] });

  return useShouldStartDismissablePrompt(promptKey);
};
